import React, { Component } from 'react';
import BookTicket from './BookTicket';
import * as constClass from '../constants/agent.js';

class Flight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dTime: '',
      aTime: '',
      flyTo: '',
      flyFrom: '',
      price: '',
      flyDuration: '',
      selectWasClicked: false
    };
  }

  check_ignore_airline_logo = (airline_identifier) => {
    const ignore_airline = Object.keys(constClass.AIRLINE_IGNORE_LOGO_LIST).indexOf(airline_identifier) > -1
    return ignore_airline  // true or false
  }

  format_datetime_string_to_date = datetime_string => {
    const dateTimeComponents = datetime_string.split('T');
    if (dateTimeComponents.length !== 2) {
        throw new Error('Invalid ISO string format');
    }

    const dateComponent = dateTimeComponents[0];
    const [year, month, day] = dateComponent.split('-');

    return `${year}/${month}/${day}`;
  }

  format_datetime_string_to_time = isoString => {
    const dateTimeComponents = isoString.split('T');
    if (dateTimeComponents.length !== 2) {
        throw new Error('Invalid ISO string format');
    }

    const timeComponent = dateTimeComponents[1].split('.')[0]; // Removing milliseconds part
    const [hours, minutes] = timeComponent.split(':');

    return `${hours}:${minutes}`;
  }

  secondsToHours = (seconds) => {
    var hours = Math.floor(seconds / 3600); // get the number of hours
    var remainingSeconds = seconds % 3600; // get the remaining seconds
    var minutes = Math.floor(remainingSeconds / 60); // get the number of minutes
  
    // construct the string
    var str = hours.toString().padStart(2, '0') + ':' +
              minutes.toString().padStart(2, '0');
  
    return str;
  }

  formatDuration = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    if (hours > 0) {
      return `${hours}h ${minutes}m`;
    }
    return `${minutes}m`;
  }

  handleSelectFlight = () => {
    console.log("SELECT clicked")
    this.setState({ selectWasClicked: !this.state.selectWasClicked })
  }

  render() {
    const selectWasClicked = this.state.selectWasClicked;
    const isDirect = this.props.data.route.length === 1;
    const stops = this.props.data.route.length - 1;

    let button;
    if (selectWasClicked){
      button = <button type="button" className="btn btn-lg btn-light" onClick={this.handleSelectFlight}>Close</button>;
    } else {
      button = <button type="button" className="btn btn-lg btn-primary" onClick={this.handleSelectFlight}>Select &rarr;</button>;
    }

    let airline_image_element;
    let airline = this.props.data.airlines[0];
    let imageUrl;
    let airlineName; // Show this text if airline logo can't be shown
    if (!this.check_ignore_airline_logo(airline)) {
      imageUrl = `https://images.kiwi.com/airlines/64/${airline}.png`;
    } else {
      imageUrl = `https://images.kiwi.com/airlines/64/non-existing.png`;
      airline = constClass.AIRLINE_IGNORE_LOGO_LIST[airline] // Airline name human readable
      airlineName = airline  // So I can conditionally show this text
    }
    airline_image_element = <img src={imageUrl} className="img-fluid" alt={airline} style={{maxHeight: '40px'}} />

    return (
    <tr className="table-light">
        <div className="container text-dark mb-4">
          <div className="card shadow-sm mb-3">
            <div className="card-body">
              <div className="row align-items-center">
                {/* Airline & Date */}
                <div className="col-12 col-md-2 text-center mb-3 mb-md-0">
                  {airline_image_element}
                  {airlineName && <div className="mt-2"><small className="text-muted">{airlineName}</small></div>}
                  <div className="mt-2">
                    <small className="text-muted">{this.format_datetime_string_to_date(this.props.data.local_departure)}</small>
                  </div>
                </div>

                {/* Departure */}
                <div className="col-12 col-md-2 text-center mb-3 mb-md-0">
                  <div className="h4 mb-1 fw-bold">{this.format_datetime_string_to_time(this.props.data.local_departure)}</div>
                  <div className="text-muted small">{this.props.data.cityFrom}</div>
                  <div className="text-muted small">({this.props.data.flyFrom})</div>
                </div>

                {/* Duration & Stops */}
                <div className="col-12 col-md-3 text-center mb-3 mb-md-0">
                  <div className="mb-2">
                    <i className="bi bi-clock me-1"></i>
                    <strong>{this.formatDuration(this.props.data.duration.total)}</strong>
                  </div>
                  <div className="text-muted small">
                    {isDirect ? (
                      <span className="badge bg-success">Direct Flight</span>
                    ) : (
                      <span>{stops} {stops === 1 ? 'stop' : 'stops'}</span>
                    )}
                  </div>
                  {isDirect && (
                    <div className="mt-1">
                      <span className="badge bg-info">Best for visa</span>
                    </div>
                  )}
                </div>

                {/* Arrival */}
                <div className="col-12 col-md-2 text-center mb-3 mb-md-0">
                  <div className="h4 mb-1 fw-bold">{this.format_datetime_string_to_time(this.props.data.local_arrival)}</div>
                  <div className="text-muted small">{this.props.data.cityTo}</div>
                  <div className="text-muted small">({this.props.data.flyTo})</div>
                </div>

                {/* Price & Action */}
                <div className="col-12 col-md-3 text-center">
                  <div className="mb-2">
                    <div className="text-decoration-line-through text-muted small">${this.props.data.price}</div>
                    <div className="h5 text-success mb-0">Free</div>
                  </div>
                  <div className="mt-2">
                    {button}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.state.selectWasClicked ? <BookTicket data={this.props.data}/> : null}
        </div>
    </tr>
    );
  }
}

export default Flight
